import * as yup from 'yup'

export const editPasswordSchema = yup.object({
	oldPassword: yup.string().required('Campo obrigatório'),
	password: yup
		.string()
		.required('Campo obrigatório')
		.min(6, 'A senha deve conter pelo menos 8 caracteres'),
	retypePassword: yup
		.string()
		.required('Campo obrigatório')
		.oneOf(
			[yup.ref('password')],
			'Ops! Suas senhas devem ser iguais, tente novamente.'
		),
})

export const editAddresschema = yup.object({
	cep: yup.string().required('Campo obrigatório'),
	address: yup.string().required('Campo obrigatório'),
	number: yup.string().required('Campo obrigatório'),
	district: yup.string().required('Campo obrigatório'),
	city: yup.string().required('Campo obrigatório'),
	state: yup.string().required('Campo obrigatório'),
})

export const editInfochema = yup.object({
	name: yup
		.string()
		.required('Campo obrigatório')
		.matches(
			/^[A-Za-zÀ-ÿ\s'-]+$/,
			'Nome inválido. Use apenas letras e espaços.'
		),
	birthdate: yup
		.string()
		.required('Campo obrigatório')
		.matches(
			/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
			'Formato inválido. Use DD/MM/AAAA'
		)
		.test('valid-date', 'Data inválida', (value) => {
			if (!value) return false

			const [day, month, year] = value.split('/').map(Number)
			const date = new Date(Date.UTC(year, month - 1, day))

			return (
				date.getUTCDate() === day &&
				date.getUTCMonth() === month - 1 &&
				date.getUTCFullYear() === year
			)
		})
		.test('min-date', 'Data mínima permitida: 01/01/1900', (value) => {
			if (!value) return false

			const [day, month, year] = value.split('/').map(Number)
			const inputDate = new Date(Date.UTC(year, month - 1, day))
			const minDate = new Date(Date.UTC(1900, 0, 1))

			return inputDate >= minDate
		}),
	whatsapp: yup.string(),
	phone: yup.string(),
})

export const editPhonechema = yup.object({
	phone: yup
		.string()
		.required('Insira ao menos seu WhatsApp.')
		.min(10, 'Por favor, insira um número com no mínimo 10 dígitos.'),
})
